import React, { useEffect, useRef, useState } from 'react';
import ErrorLabel from '../ErrorLabel';
import styled from 'styled-components';
import { FormikErrors, FormikTouched, FormikValues, FormikHandlers } from 'formik';

import { transformLabels } from '../../../../utils/misc';
import { Colors } from '../../../../scss/common/style';

import openEye from '../../../../static/img/eyeIcon.svg';
import closedEye from '../../../../static/img/eyeClosedIcon.svg';

interface Props {
  id?: string;
  name: string;
  value: string | number;
  cols?: number;
  type?: string;
  label?: string | undefined;
  disabled?: boolean;
  inline?: boolean;
  onBlur?: FormikHandlers['handleBlur'];
  onChange: FormikHandlers['handleChange'];
  touched?: FormikTouched<FormikValues>;
  errors?: FormikErrors<FormikValues>;
  inlineStyles?: any[];
  password?: boolean;
  height?: string | number;
  colorLabel?: string;
  autocomplete?: string;
}

export default function TextInputComponent({
  id,
  name,
  value,
  onBlur,
  onChange,
  cols = 6,
  type = 'text',
  label,
  disabled = false,
  touched,
  errors,
  inline = false,
  inlineStyles,
  password = false,
  height,
  colorLabel,
  ...rest
}: Props): JSX.Element {
  const quantityInputRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    const ignoreScroll = (e) => {
      e.preventDefault();
    };
    quantityInputRef.current && quantityInputRef.current.addEventListener('wheel', ignoreScroll);
  }, [quantityInputRef]);

  // if (label === undefined) {
  //   label = transformLabels(name);
  // }

  return (
    <>
      {inline ? (
        <div style={{ height: '100%', display: 'inline' }}>
          {label != undefined && (
            <LabelStyle
              colorLabel={colorLabel}
              className="ak-form-labels"
              {...(id ? { htmlFor: id } : {})}
              style={{ marginBottom: 7 }}
            >
              {label}
            </LabelStyle>
          )}
          <Input
            ref={quantityInputRef}
            {...(id ? { id } : {})}
            type={type}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            height={height}
            className="form-control  "
            disabled={disabled}
            style={{
              marginBottom: '0px !important',
              display: 'inline',
              width: 'auto',
              ...inlineStyles,
            }}
            {...rest}
          />
          {touched?.[name] || (errors?.[name] && <ErrorLabel error={errors?.[name]} />)}
        </div>
      ) : (
        <WrapperInput className={`col-sm-${cols}`}>
          {label != undefined && (
            <LabelStyle colorLabel={colorLabel} className="ak-form-labels" {...(id ? { htmlFor: id } : {})}>
              {label ?? transformLabels(label)}
            </LabelStyle>
          )}
          <Input
            ref={quantityInputRef}
            {...(id ? { id } : {})}
            type={showPassword ? 'text' : type}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            className="form-control "
            disabled={disabled}
            {...rest}
            height={height}
          />
          {touched?.[name] || (errors?.[name] && <ErrorLabel error={errors?.[name]} />)}
          {password &&
            (showPassword ? (
              <ImageEye src={openEye} onClick={(): void => setShowPassword(!showPassword)} />
            ) : (
              <ImageEye src={closedEye} onClick={(): void => setShowPassword(!showPassword)} />
            ))}
        </WrapperInput>
      )}
    </>
  );
}

const WrapperInput = styled.div`
  padding: 0;
`;

const ImageEye = styled.img`
  position: absolute;
  bottom: 8px;
  right: 25px;
  width: 17px;
  height: auto;
  cursor: pointer;
`;

const LabelStyle = styled.label`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: ${(props) => (props.colorLabel ? props.colorLabel : Colors.darkBrown)};
  text-align: left;
  width: 100%;
  margin-left: 8px;
  margin-bottom: 11px;
  margin-right: 6px;
`;

const Input = styled.input`
  height: ${(props) => (props.height ? props.height : 33)}px;
  padding: 0 !important;
  padding-left: 10px !important;
  border-color: #eeeeee !important;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  border: 1px solid #eeeeee;
  border-radius: 200px;
  &:active {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
  &:hover {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
  &:focus {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
`;
